var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import Context from './Context';
import ReactIcon from './IconBase';
import { getTwoToneColor, setTwoToneColor } from './twoTonePrimaryColor';
import { normalizeTwoToneColors } from '../utils';
// Initial setting
// should move it to antd main repo?
setTwoToneColor('#1890ff');
var Icon = React.forwardRef(function (props, ref) {
    var _a;
    var 
    // affect outter <i>...</i>
    className = props.className, 
    // affect inner <svg>...</svg>
    icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, 
    // other
    twoToneColor = props.twoToneColor, restProps = __rest(props, ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"]);
    var _b = React.useContext(Context).prefixCls, prefixCls = _b === void 0 ? 'anticon' : _b;
    var classString = classNames(prefixCls, (_a = {},
        _a["".concat(prefixCls, "-").concat(icon.name)] = !!icon.name,
        _a["".concat(prefixCls, "-spin")] = !!spin || icon.name === 'loading',
        _a), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) {
        iconTabIndex = -1;
    }
    var svgStyle = rotate
        ? {
            msTransform: "rotate(".concat(rotate, "deg)"),
            transform: "rotate(".concat(rotate, "deg)")
        }
        : undefined;
    var _c = normalizeTwoToneColors(twoToneColor), primaryColor = _c[0], secondaryColor = _c[1];
    return (React.createElement("span", __assign({ role: "img", "aria-label": icon.name }, restProps, { ref: ref, tabIndex: iconTabIndex, onClick: onClick, className: classString }),
        React.createElement(ReactIcon, { icon: icon, primaryColor: primaryColor, secondaryColor: secondaryColor, style: svgStyle })));
});
Icon.displayName = 'AntdIcon';
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor;
export default Icon;
